/** Recipient's subsidiary / employer — chosen only from this customer's recorded subsidiaries; never guessed, never the ordering customer. */
import { useEffect, useState } from "react";
import api from "@/lib/api";

const link = "text-[11px] font-semibold underline";

export function SubsidiaryPicker({ orderId, current, onChange, testid = "subsidiary-picker" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!open || !orderId) return undefined;
    const t = setTimeout(() => api.get(`/end-client/orders/${orderId}/subsidiaries`, { params: q.trim() ? { q: q.trim() } : {} })
      .then(({ data }) => setItems(data.items || [])).catch(() => setItems([])), 250);
    return () => clearTimeout(t);
  }, [open, q, orderId]);
  const pick = (company_id, company) => { onChange({ company_id, company }); setOpen(false); setQ(""); };
  return (
    <div className="rounded-md border border-slate-200 bg-white p-2" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-2 text-[12px]">
        <span className="text-slate-500">Subsidiary / employer</span>
        {current ? <b className="uppercase text-slate-900" data-testid={`${testid}-current`}>{current}</b>
          : <span className="rounded bg-amber-50 px-1.5 py-0.5 text-[11px] font-semibold text-amber-800" data-testid={`${testid}-none`}>No subsidiary set</span>}
        <button type="button" onClick={() => setOpen(!open)} className={`ml-auto ${link} text-indigo-700`} data-testid={`${testid}-toggle`}>{open ? "Close" : current ? "Change" : "Choose subsidiary"}</button>
        {current && <button type="button" onClick={() => pick("", "")} className={`${link} text-slate-500`} data-testid={`${testid}-clear`}>Clear</button>}
      </div>
      {open && <div className="mt-2 space-y-1">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search this customer's subsidiaries" className="h-8 w-full rounded-md border border-slate-300 px-2 text-[12px]" data-testid={`${testid}-search`} />
        <div className="max-h-40 overflow-y-auto rounded border border-slate-100">
          {items === null ? <div className="p-2 text-[11px] text-slate-400">Loading…</div>
            : items.length ? items.map((s) => <button type="button" key={s.id} onClick={() => pick(s.id, s.name)} className="block w-full px-2 py-1 text-left text-[12px] hover:bg-slate-50" data-testid={`${testid}-option-${s.id}`}>{s.name}</button>)
              : <div className="p-2 text-[11px] text-slate-500" data-testid={`${testid}-empty`}>No subsidiaries are recorded for this customer{q ? " matching that search" : ""}. Add the subsidiary in Customers first; nothing is guessed.</div>}
        </div>
      </div>}
    </div>
  );
}
